import React, { useState, useEffect } from "react";
import { Modal, Button, Form, Table } from "react-bootstrap";
import API from "../api"; // ✅ assuming you have a central Axios instance
import "bootstrap/dist/css/bootstrap.min.css";
import { useAuth } from "../context/AuthContext";

export default function MessageManagerPage() {
  const { user } = useAuth();
  const [messages, setMessages] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [editingMessage, setEditingMessage] = useState(null);
  const [form, setForm] = useState({
    leagueid: user?.leagueid || "",
    message: "",
    startdate: "",
    enddate: ""
  });

  const fetchMessages = async () => {
    try {
      const res = await API.get(`/scorecard/messages/${user.leagueid}`);
      setMessages(res.data);
    } catch (err) {
      console.error("Failed to fetch messages", err);
    }
  };

  useEffect(() => {
    if (user?.leagueid) {
      fetchMessages();
    }
  }, [user]);

  const handleOpenModal = (message = null) => {
    if (message) {
      setEditingMessage(message);
      setForm({
        leagueid: message.leagueid,
        message: message.message,
        startdate: message.startdate,
        enddate: message.enddate
      });
    } else {
      setEditingMessage(null);
      setForm({
        leagueid: user?.leagueid || "",
        message: "",
        startdate: "",
        enddate: ""
      });
    }
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSave = async () => {
    try {
      if (editingMessage) {
        await API.put(`/scorecard/messages/${editingMessage.id}`, form);
      } else {
        await API.post("/scorecard/messages", form);
      }
      fetchMessages();
      setShowModal(false);
    } catch (err) {
      console.error("Failed to save message", err);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this message?")) return;
    try {
      await API.delete(`/scorecard/messages/${id}`);
      fetchMessages();
    } catch (err) {
      console.error("Failed to delete message", err);
    }
  };

  return (
    <div className="container mt-4">
      <h3>Manage Messages</h3>
      <Button className="mb-3" onClick={() => handleOpenModal()}>
        Add New Message
      </Button>

      <Table striped bordered hover>
        <thead>
          <tr>
            <th>Message</th>
            <th>Start Date</th>
            <th>End Date</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {messages.map(msg => (
            <tr key={msg.id}>
              <td>{msg.message}</td>
              <td>{msg.startdate}</td>
              <td>{msg.enddate}</td>
              <td>
                <Button variant="info" size="sm" onClick={() => handleOpenModal(msg)}>
                  Edit
                </Button>{" "}
                <Button variant="danger" size="sm" onClick={() => handleDelete(msg.id)}>
                  Delete
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>

      <Modal show={showModal} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>{editingMessage ? "Edit Message" : "Add Message"}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            {/* League ID is hidden */}
            <Form.Control
              type="hidden"
              name="leagueid"
              value={form.leagueid}
            />

            <Form.Group controlId="message" className="mb-3">
              <Form.Label>Message</Form.Label>
              <Form.Control
                as="textarea"
                name="message"
                rows={3}
                value={form.message}
                onChange={handleChange}
                required
              />
            </Form.Group>

            <Form.Group controlId="startdate" className="mb-3">
              <Form.Label>Start Date</Form.Label>
              <Form.Control
                type="date"
                name="startdate"
                value={form.startdate}
                onChange={handleChange}
                required
              />
            </Form.Group>

            <Form.Group controlId="enddate" className="mb-3">
              <Form.Label>End Date</Form.Label>
              <Form.Control
                type="date"
                name="enddate"
                value={form.enddate}
                onChange={handleChange}
                required
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleSave}>
            {editingMessage ? "Update" : "Create"}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}
